export const FIELD_TYPE = {
  SELECT: 'SELECT',
  DATE: 'DATE',
  TEXT: 'TEXT',
}
